import React, { useEffect } from "react";
import AboutBanner from "../components/About/AboutBanner";
import WhyWeAre from "../components/About/WhyWeAre";
import AboutVideo from "../components/About/AboutVideo";
import Timeline from "../components/About/Timeline";
import GetINTouch from "../components/Contactus/GetINTouch";
export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);

  return (
    <>
      <AboutBanner />
      <AboutVideo />
      <WhyWeAre />
      <Timeline />
      <GetINTouch />
    </>
  );
}
